<template>
  <div class="content">
    <div class="page-inner">
      <h1 class="mb-4 fw-thin">
        SmartLinks
      </h1>

      <div class="card">
        <div class="card-body" v-if="!loading && !distributions.length">
          {{ $t('you_need_release_published') }}
        </div>
        <div class="card-body p-0" v-if="!loading && distributions.length">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>{{ $t('release') }}</th>
                  <th class="d-none d-sm-table-cell">{{ $t('artist') }}</th>
                  <th class="d-none d-sm-table-cell">{{ $t('store') }}</th>
                  <th>Link</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(smartlink, index) in smartlinks" v-bind:key="`row_${index}`">
                  <td>
                    <router-link :to="`/tools/smartlinks/${smartlink._id}`">
                      {{ smartlink.distribution.title }}
                    </router-link>
                  </td>
                  <td class="d-none d-sm-table-cell">
                    {{ smartlink.artist.name }}
                  </td>
                  <td class="d-none d-sm-table-cell">
                    {{ getStoreNames(smartlink) }}
                  </td>
                  <td>
                    <a :href="`https://indfy.me/${smartlink.key}`" target="_blank">
                      https://indfy.me/{{ smartlink.key }}
                    </a>
                  </td>
                  <td class="text-right">
                    <router-link :to="`/tools/smartlinks/${smartlink._id}`" tagName="button" type="button" class="btn btn-sm btn-default">
                      {{ $t('edit') }}
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import Distributions from '../services/distributions'
import Smartlinks from '../services/smartlinks'

export default {
  name: 'Smartlinks',
  data: function () {
    return {
      loading: true,
      smartlinks: [],
      distribuitions: [],
      user: {}
    }
  },
  methods: {
    getStoreNames: function (smartlink) {
      let stores = []

      _.each(smartlink.stores, item => {
        stores.push(item.name)
      })

      return stores.join(', ')
    },
    generateSmartlinks: function () {
      let currentIndex = 0
      let generateSmartlink = () => {
        let distro = this.distributions[currentIndex]

        if (distro) {
          if (!_.find(this.smartlinks, item => item.distribution._id === distro._id)) {
            Distributions.getStores(distro._id).then(response => {
              this.smartlinks.push(response.data)
              currentIndex++
              generateSmartlink()
            }).catch(() => {
              currentIndex++
              generateSmartlink()
            })
          } else {
            currentIndex++
            generateSmartlink()
          }
        }
      }

      generateSmartlink()
    }
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)
    }, 100)
  },
  created: function () {
    this.user = this.$user

    Smartlinks.getAll().then(response => {
      this.smartlinks = response.data

      Distributions.getAll({ status: 3 }).then(response => {
        this.distributions = response.data

        if (this.distributions.length > this.smartlinks.length) {
          this.generateSmartlinks()
        }

        this.loading = false
      })
    })

    window.document.title = this.$t('services_title') + ' | Indiefy'
    window.$('meta[name="description"]').attr('content', this.$t('services_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('services_description'))
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Smartlinks.vue